<template>
  <component
    :is="tag"
    v-bind="attrTag"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>

export default {
  name: 'TagLink',
  props: {
    tag: {
      type: String,
      default: '',
      validator (tagType) {
        const types = ['a', 'nuxt-link']
        return types.includes(tagType)
      }
    },
    attrTag: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
